import React, { Component } from 'react';
import { imageBasePath, appBasePath } from '../../constants/staticData';

export default class PackagesComponent extends Component {
    constructor(props) {
        super(props);
    }




    render() {
        return (
            <div>
                <div className="empty-list-display packages-empty-list-mob">
                      <img src={`${imageBasePath}/no_jobs.png`} alt="No User Details"></img>
                      <h5>Currently no packages available.</h5>
                    </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/UserAccounts/PackagesComponent.jsx